module.exports = __webpack_public_path__ + "static/media/EFAVeloz-Horizontal-White-1536x326.9669b76e.png";